import Choices from 'choices.js';

const choicesConfig = {
  searchEnabled: true,
  removeItemButton: true,
  itemSelectText: '',
  classNames: {
    // containerOuter: ['choices', 'form-select-wrapper'],
    // containerInner: ['choices__inner', 'form-control'],
    // input: ['choices__input', 'form-control'],
    // inputCloned: ['choices__input--cloned', 'form-control'],
    // list: 'choices__list',
    // listItems: 'choices__list--multiple',
    // listSingle: 'choices__list--single',
    // listDropdown: ['choices__list--dropdown', 'dropdown-menu'],
    // item: 'choices__item',
    // itemSelectable: ['choices__item--selectable', 'badge', 'bg-primary'],
    // itemDisabled: 'choices__item--disabled',
    // itemChoice: ['choices__item--choice', 'dropdown-item'],
    // placeholder: 'choices__placeholder',
    // group: ['choices__group', 'dropdown-header'],
    // groupHeading: 'choices__heading',
    // button: ['choices__button', 'btn-close'],
    // activeState: 'is-active',
    // focusState: 'is-focused',
    // openState: 'is-open',
    // disabledState: 'is-disabled',
    // highlightedState: ['is-highlighted', 'text-primary'],
    // selectedState: 'is-selected',
    // flippedState: 'is-flipped',
    // loadingState: 'is-loading'
  }
};

['DOMContentLoaded', 'shown.bs.modal', 'modal.inner_html.loaded', 'cocoon:after-insert'].forEach(function(e) {
  document.addEventListener(e, function(event) {
    const selectElements = document.querySelectorAll('.js-choice');
    selectElements.forEach(element => {
      // Check if element already has a Choices instance
      if (!element.choicesInstance) {
        element.choicesInstance = new Choices(element, choicesConfig);
      }
    });
  });
});
